export const NEWS_ITEM_DATA_ATTRIBUTE = 'data-news-item'
export const HEADER_MOBILE_MENU_OPEN_BTN_ATTRIBUTE =
  'data-header-mobile-menu-open-btn'
export const TAG_WITH_MISSING_AMP_MANDATORY_ATTR_DATA_ATTRIBUTE =
  'data-tag-with-missing-amp-mandatory-attr'
export const ELEMENT_WIDTH = 'data-width'
export const ELEMENT_HEIGHT = 'data-height'
